import { render, staticRenderFns } from "./_exchangeRate.vue?vue&type=template&id=5cc01f22&lang=pug"
import script from "./_exchangeRate.vue?vue&type=script&lang=js"
export * from "./_exchangeRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports